<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { UnorderedListOutlined } from '@ant-design/icons-vue'

const open = ref(false)
const route = useRoute()
const router = useRouter()
const activeKey = ref('')
const coreKey = ref('')
const industryList = [
  {
    name: 'Robrain AI机器人解决方案',
    key: 'Robrain',
    route: 'solutions/robrain',
  },
  {
    name: 'AI具身理疗机器人解决方案',
    key: 'robotherapist',
    route: 'solutions/robotherapist',
  },
  {
    name: 'AI商业服务机器人解决方案',
    key: 'businessRobot',
    route: 'solutions/service_robot',
  },
  {
    name: 'OpenVending AI智能识别秤解决方案',
    key: 'openVend',
    route: 'solutions/smart_scale',
  },
  {
    name: 'OpenVending AI智能无人零售解决方案',
    key: 'smartRetail',
    route: 'solutions/smart_vending_machine',
  },
  {
    name: 'AI语音助手解决方案',
    key: 'voiceAssistant',
    route: 'voice_assistant',
  },
  {
    name: 'AI音频模组解决方案',
    key: 'pectorophony',
    route: 'solutions/audio_modules',
  },
  {
    name: 'AI玩具解决方案',
    key: 'aiToys',
    route: 'ai-solutions/smart_toys',
  },
]
const routeName = route.name
const solutionRoute = [
  'pectorophony',
  'Robrain',
  'openVend',
  'voiceAssistant',
  'businessRobot',
  'robotV2',
  'smartRetail',
  'robotherapist',
]

const coreList = [
  {
    name: '端侧AI大模型',
    key: 'edge_ai',
    route: 'core_capabilities/edge_ai',
  },
  {
    name: '端云融合AI Agent',
    key: 'cloud_ai',
    route: 'core_capabilities/edge_cloud_ai',
  },
  {
    name: 'AI音频算法',
    key: 'audio_ai',
    route: 'core_capabilities/ai_audio',
  },
  {
    name: 'AI视觉算法',
    key: 'vision_ai',
    route: 'core_capabilities/ai_vision',
  },
]
const coreRoute = ['edge_ai', 'cloud_ai', 'audio_ai', 'vision_ai']

const showDrawer = () => {
  open.value = !open.value
}

const goToRoute = (routename) => {
  router.push(`/${routename}`)
}

// 检查屏幕尺寸的函数
const checkScreenSize = () => {
  // 当屏幕宽度大于992px时，设置open为false
  if (window.innerWidth > 992) {
    open.value = false
  }
}

// 定义resize处理函数
const handleResize = () => {
  checkScreenSize()
}

// 组件挂载时执行
onMounted(() => {
  // 初始检查
  checkScreenSize()
  // 添加窗口大小变化监听
  window.addEventListener('resize', handleResize)
})

// 组件卸载时执行
onUnmounted(() => {
  // 移除监听，防止内存泄漏
  window.removeEventListener('resize', handleResize)
})
</script>

<template>
  <span class="option options-button">
    <span @click="showDrawer"><UnorderedListOutlined class="ft24" /></span>
  </span>

  <!-- 抽屉蒙层 -->
  <div v-if="open" class="overlay" @click="showDrawer"></div>

  <div
    @click.stop
    :class="['drawer', 'drawer-right', open ? 'drawer-left' : 'drawer-right']"
  >
    <p
      :class="['item', 'pd-10', routeName === 'home' && 'high-light']"
      @click="goToRoute('home')"
    >
      首页
    </p>
    <!-- <p
      :class="['item', 'pd-10', routeName === 'core' && 'high-light']"
      @click="goToRoute('core')"
    >
      核心能力
    </p> -->
    <p>
      <a-collapse
        v-model:activeKey="coreKey"
        :bordered="false"
        expand-icon-position="end"
        :class="[coreRoute.includes(routeName) && 'high-light2']"
      >
        <a-collapse-panel key="1" header="核心能力">
          <p
            v-for="(item, idx) in coreList"
            :key="idx"
            @click="goToRoute(item.route)"
            :class="['item', routeName === item.key && 'high-light']"
          >
            {{ item.name }}
          </p>
        </a-collapse-panel>
      </a-collapse>
    </p>
    <p
      :class="['item', 'pd-10', routeName === 'aimarket' && 'high-light']"
      @click="goToRoute('algostore')"
    >
      算法超市
    </p>
    <p>
      <a-collapse
        v-model:activeKey="activeKey"
        :bordered="false"
        expand-icon-position="end"
        :class="[solutionRoute.includes(routeName) && 'high-light2']"
      >
        <a-collapse-panel key="1" header="解决方案">
          <p
            v-for="(item, idx) in industryList"
            :key="idx"
            @click="goToRoute(item.route)"
            :class="['item', routeName === item.key && 'high-light']"
          >
            {{ item.name }}
          </p>
        </a-collapse-panel>
      </a-collapse>
    </p>
  </div>
</template>

<style scoped lang="scss">
.pd-10 {
  padding-right: 10px;
}
.option {
  line-height: 77px;
}
.ft24 {
  font-size: 24px;
  cursor: pointer;
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
}

.drawer {
  z-index: 13;
  height: calc(100vh - 111px);
  overflow-y: auto;
  padding: 0.75rem 0;
  top: 111px;
  right: 0;
  width: 420px;
  position: absolute;
  background: #e9ecec;
  transition: transform 0.3s ease-out;
  transform: translateX(100%);

  .item {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #1a1a1a;
    font-size: 15px;
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;

    &:hover {
      color: #ed000c;
    }
  }
}

.high-light.item {
  color: #ed000c;
}

.drawer-left {
  transform: translateX(0);
  visibility: visible;
}

@media (max-width: 991px) {
  .options-button {
    visibility: visible;
  }
}
@media (min-width: 991px) {
  .options-button {
    visibility: hidden;
  }
}

@media (min-width: 991px) {
  .drawer-right {
    transform: translateX(100%) !important;
    visibility: hidden !important;
  }
}

:deep() {
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 12px 1.5rem;
    background-color: #e9ecec;
  }

  .ant-collapse-borderless
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    background-color: #e9ecec;
  }

  .high-light2 {
    & > .ant-collapse-item > .ant-collapse-header {
      color: #ed000c !important;
    }
  }
}
</style>
